import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ModuleGate } from '@/components/module-gate'
import { ImportHub } from '@/components/import/import-hub'
import { IMPORT_STEPS } from '@/lib/import-steps'

/**
 * The step lives in the URL so browser back/forward and direct entry work.
 *
 * `catch` rather than a hard failure: a stale link or a hand-edited URL must
 * land on Upload, not on a router error page. What the session can actually
 * support is reconciled separately by `resolveImportStep` — the URL only ever
 * expresses a REQUEST, never evidence that the step is reachable.
 */
const searchSchema = z.object({
  step: z.enum(IMPORT_STEPS).catch('upload').optional(),
})

export const Route = createFileRoute('/_authed/import')({
  validateSearch: searchSchema,
  component: () => (
    <ModuleGate moduleKey="import">
      <ImportHub />
    </ModuleGate>
  ),
})
